export const ROLE = {
  ADMIN: 'ADMIN',
  ASSET_MGR: 'ASSET_MGR',
  AUDITOR: 'AUDITOR',
  USER: 'USER'
}

export const ROLE_LABEL = {
  ADMIN: '系统管理员',
  ASSET_MGR: '资产管理员',
  AUDITOR: '审核员',
  USER: '普通用户'
}

const FALLBACK_MENUS = {
  ADMIN: [
    'dashboard',
    'aiArchive',
    'assetList', 'assetQuery', 'assetCategory', 'assetExpire', 'deviceManage',
    'requisition', 'requisitionApprove', 'requisitionApprove2', 'requisitionIssue', 'requisitionReturn', 'requisitionCancel',
    'inventory',
    'purchase', 'purchaseApprove1', 'purchaseApprove2', 'purchaseConfirm', 'purchaseCancel',
    'lend', 'lendApprove1', 'lendApprove2', 'lendReturn', 'lendCancel',
    'allocation', 'allocationApprove', 'allocationConfirm', 'allocationCancel',
    'repair', 'repairApprove', 'repairConfirm', 'repairDone', 'repairCancel',
    'disposal', 'disposalApprove', 'disposalConfirm', 'disposalCancel',
    'consumable', 'consumableIssue',
    'report', 'reportAssetCategory', 'reportDepartment', 'reportDepreciationSummary', 'reportDepreciationStat', 'reportDepreciationDetail',
    'alarmList', 'positioning',
    'orgManage', 'dictManage', 'sysLog', 'depreciationConfig', 'workloadConfig',
    'sysUser', 'sysRole', 'openAccount'
  ],
  ASSET_MGR: [
    'dashboard',
    'aiArchive',
    'assetList', 'assetQuery', 'assetCategory', 'assetExpire', 'deviceManage',
    'requisition', 'requisitionApprove', 'requisitionApprove2', 'requisitionIssue', 'requisitionReturn', 'requisitionCancel',
    'inventory',
    'purchase', 'purchaseApprove1', 'purchaseApprove2', 'purchaseConfirm', 'purchaseCancel',
    'lend', 'lendApprove1', 'lendApprove2', 'lendReturn', 'lendCancel',
    'allocation', 'allocationApprove', 'allocationConfirm', 'allocationCancel',
    'repair', 'repairApprove', 'repairConfirm', 'repairDone', 'repairCancel',
    'disposal', 'disposalApprove', 'disposalConfirm', 'disposalCancel',
    'consumable', 'consumableIssue',
    'report', 'reportAssetCategory', 'reportDepartment', 'reportDepreciationSummary', 'reportDepreciationStat', 'reportDepreciationDetail',
    'alarmList', 'positioning'
  ],
  AUDITOR: [
    'dashboard', 'requisition', 'requisitionApprove', 'requisitionApprove2', 'inventory',
    'purchase', 'purchaseApprove1', 'purchaseApprove2', 'lend', 'lendApprove1', 'lendApprove2',
    'allocation', 'allocationApprove', 'repair', 'repairApprove', 'disposal', 'disposalApprove',
    'report', 'reportAssetCategory', 'reportDepartment'
  ],
  USER: ['dashboard', 'aiArchive', 'assetList', 'assetQuery']
}

const SYSTEM_MENUS = [
  'orgManage', 'dictManage', 'sysLog', 'depreciationConfig', 'workloadConfig',
  'sysUser', 'sysRole', 'openAccount'
]

/** 平台超级管理员用户名：唯一可开通 / 冻结 / 注销租户 */
export const SUPER_ADMIN_USERNAME = 'admin'

/** 仅超级管理员可见（试用 ADMIN 不给） */
const SUPER_ADMIN_ONLY_MENUS = ['openAccount']

export function isSuperAdmin(userInfo) {
  return !!(userInfo && userInfo.username === SUPER_ADMIN_USERNAME)
}

export function menusForUser(userInfo) {
  const role = (userInfo && userInfo.role) || ROLE.ADMIN
  let menus
  if (userInfo && Array.isArray(userInfo.menus) && userInfo.menus.length) {
    menus = userInfo.menus.slice()
  } else {
    menus = (FALLBACK_MENUS[role] || FALLBACK_MENUS.ADMIN).slice()
  }
  if (role !== ROLE.ADMIN) {
    menus = menus.filter(p => !SYSTEM_MENUS.includes(p))
  }
  if (!isSuperAdmin(userInfo)) {
    menus = menus.filter(p => !SUPER_ADMIN_ONLY_MENUS.includes(p))
  }
  if (!menus.includes('dashboard')) {
    menus.unshift('dashboard')
  }
  return menus
}

export function canAccessPath(userInfoOrRole, path) {
  const clean = (path || '').replace(/^\//, '')
  if (!clean || clean === 'login') return true
  if (typeof userInfoOrRole === 'string') {
    return menusForUser({ role: userInfoOrRole }).includes(clean)
  }
  return menusForUser(userInfoOrRole).includes(clean)
}
